import { Outlet, useOutletContext } from 'react-router-dom'

import { TrainingSessionsByEmployeeDataTableQuery } from 'generated/resources/datatable.graphql'

type TrainingsSessionAccessMembership = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<TrainingSessionsByEmployeeDataTableQuery['trainings']>['sessionsConnection']
    >['edges'][0]
  >['node']
>

const EmployeeNextSessionCertificates = () => {
  const { employeeId, employeeAccessId, session } = useOutletContext<{
    employeeId: string
    employeeAccessId: string
    session: TrainingsSessionAccessMembership
  }>()
  return <Outlet context={{ employeeId, employeeAccessId, session }} />
}

export default EmployeeNextSessionCertificates
